import React, { useState } from "react";
import Logisticsorders from "./Logisticsorders";
import Logisticsorderdetails from "./Logisticsorderdetails";


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Status");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Status":
        return <Logisticsorders />;
      case "Reports":
        return <Logisticsorderdetails />;
    //   case "Summery":
    //     return <Foodsubscribedclients title="Summery" />;
     
      default:
        return <Logisticsorders />;
    }
  };

  const tabs = [
    "Status",
    "Reports",
   
  
  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

